import TabPanel from './tab-panel'

export default TabPanel
